import { render } from "./CarryBagCard.vue?vue&type=template&id=5a082c97&scoped=true"
import script from "./CarryBagCard.vue?vue&type=script&lang=js"
export * from "./CarryBagCard.vue?vue&type=script&lang=js"

import "./CarryBagCard.vue?vue&type=style&index=0&id=5a082c97&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a082c97"]])

export default __exports__